import React, {
  useEffect,
  useState,
  useRef,
  useContext,
  useCallback,
} from "react";
import Header from "../../sharedComponent/Header";
import Carousel from "react-bootstrap/Carousel";
import bg_slid_lightGreen from "../../assets/images/bg_slid_lightGreen.png";
import bg_slide_blue from "../../assets/images/bg_slide_blue.png";
import bg_slide_green1 from "../../assets/images/bg1.jpg";
import bg_slide_green2 from "../../assets/images/slide3.jpg";
import bg_slide_green3 from "../../assets/images/slide4.jpg";
import bg_slide_green4 from "../../assets/images/slide5.jpg";
import bg_slide_green5 from "../../assets/images/slide10.jpg";
import bg_slide_green6 from "../../assets/images/slide13.jpg";
import bg_slide_green7 from "../../assets/images/sp2.jpg";
import bg_slide_green8 from "../../assets/images/sp4.jpg";
import bg_slide_green9 from "../../assets/images/sp5.jpg";
import dog_flying from "../../assets/images/dog_flying.png";
import doctor from "../../assets/images/doctor.png";
import medicine from "../../assets/images/medicine.png";
import medicine1 from "../../assets/images/medicine1.png";
import pdct1 from "../../assets/images/pdct1.png";
import { ScrollMenu } from "react-horizontal-scrolling-menu";
import dr_1 from "../../assets/images/biry.jpg";
import dr_2 from "../../assets/images/biry.jpg";
import dog_1 from "../../assets/images/biry.jpg";
import dog_2 from "../../assets/images/biry.jpg";
import { ChevronLeft, ChevronRight } from "lucide-react"; // for clean arrow icons
import ic_heart_blank from "../../assets/images/ic_heart_blank.svg";
import ic_arrow_right_green from "../../assets/images/ic_arrow_right_green.svg";
import ic_arrow_right_white from "../../assets/images/ic_arrow_right_white.svg";

import ic_added_item from "../../assets/images/ic_added_item.svg";
import ic_heart_filled from "../../assets/images/ic_heart_filled.svg";
import ic_right_arrow_circle from "../../assets/images/ic_right_arrow_circle.svg";
import ic_whatsapp from "../../assets/images/ic_whatsapp.svg";
import ic_rating_start from "../../assets/images/ic_rating_start.svg";
import ic_google from "../../assets/images/ic_google.svg";
import ic_playstore from "../../assets/images/ic_playstore.svg";
import ic_appstore from "../../assets/images/ic_appstore.svg";
import ic_bag_light from "../../assets/images/ic_bag_light.svg";
import logo from "../../assets/images/logo.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import ApiConfig from "../../api/ApiConfig";
import {
  GetWithAuth,
  PostCallWithErrorResponse,
  postWithAuthCallWithErrorResponse,
  simpleGetCall,
  simpleGetCallWithErrorResponse,
  simpleGetCallWithErrorResponseWife,
  PatchMultipartWithAuthCallWithErrorResponse,
  timeAndDistance,
} from "../../api/ApiServices";
import { AppContext } from "../../context/AppContext";
import { notifyError, notifySuccess } from "../../sharedComponent/notify";

import AppDownloadPromptWrapper from "../../sharedComponent/AppDownloadPrompt/AppDownloadPromptWrapper";
import SkeletonLoader from "./SkeletonLoader";
import VariationModal from "../../utils/variationModal/VariationModal";
import { getAddonDataArr } from "../../utils/AddonService";
import HomeMenuSection from "../Menu/HomeMenuSection";

const Home = () => {
  const {
    // loginData,
    setStoresList,
    selectedStore,
    setSelectedStore,
    selectedStroeObject,
    setDeliveryDistance,
    searchTerm,
    setSearchTerm,
    setRestaurantDispatchSettings,
    setRestaurantDetails,
    setRestaurantGeofenceRadiusKm,
    selected_location,
    set_selected_location,
    setMenuCategoryList,
    MenuCategoryList,
    setSelectedStoreObject,
    setRestaurantConfig,
    subscribeToEvent , defaultImgs, setDefaultImgs,
    validateOrderCapacityType
  } = useContext(AppContext);
  const loginData = JSON.parse(localStorage.getItem("LOGIN_DATA"));
  console.log("loginData--", loginData?.id);
     const extraParam =
        validateOrderCapacityType === 'delivery_capacity'
          ? '&order_type=takeaway'
          : validateOrderCapacityType === 'kitchen_capacity'
          ? '&ready_to_use=true'
          : '';
  const [showPrompt, setShowPrompt] = useState(true);

  const [itemsAdded, setItemsAdded] = useState({}); // { [itemId]: true }
  const [menuList, setMenuList] = useState([]);
  const [count, setCount] = useState(0);
  const [countCart, setCountCart] = useState(0);
  const  [showVariationModal , setShowVariationModal] = useState(false)

  const topScroll = () => {
    window.scrollTo(0, 0);
  };

  // const [MenuCategoryList, setMenuCategoryList] = useState([]);
  console.log("MenuCategoryList", MenuCategoryList);
  const [isApiLoad, setIsLoad] = useState(false);

  const scrollRef = useRef(null);
  const scrollRefSearch = useRef(null);
  const scrollRefRe = useRef(null);
  const scrollRefPopular = useRef(null);
  const [isAutoScrolling, setIsAutoScrolling] = useState(true);
  const [menuPopularList, setMenuPopularList] = useState([]);
  const [selected_location_2, setselected_location] = useState([]);
  const [variationData, setVariationData] = useState([]);

  const handleOpenVariationModal = (item) => {
    setVariationData(item);
    setShowVariationModal(true)
  }
  const handleCloseVariationModal = ()=>{
    setShowVariationModal(false);
  }
  
  const handleAddToCart = (item) => {
   
    if(item.item_allow_variation == 1 || item.item_allow_addon) {

       handleOpenVariationModal(item)
       return ;
    }
    setItemsAdded((prev) => ({ ...prev, [item.item_id]: true }));
    addToCart(item);
  };

  const handleAddToCartVariation = ( item , variationId) => {
    setItemsAdded((prev) => ({ ...prev, [item.item_id]: true }));
    addToCart(item, variationId);
    setShowVariationModal(false);
  }

  const animationRef = useRef(null);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container || !isAutoScrolling) return;

    const speed = 0.7; // pixels per frame, adjust for speed

    const scrollStep = () => {
      if (!container) return;
      container.scrollLeft += speed;

      // When reaching end, scroll back to start
      if (
        container.scrollLeft + container.clientWidth >=
        container.scrollWidth - 1
      ) {
        container.scrollLeft = 0;
      }

      animationRef.current = requestAnimationFrame(scrollStep);
    };

    animationRef.current = requestAnimationFrame(scrollStep);

    return () => cancelAnimationFrame(animationRef.current);
  }, [isAutoScrolling]);

  // 🔸 Manual scroll buttons
  const scroll = (direction) => {
    if (scrollRef.current) {
      const amount = 300; // pixels to scroll per click
      scrollRef.current.scrollBy({
        left: direction === "left" ? -amount : amount,
        behavior: "smooth",
      });
      setIsAutoScrolling(false); // pause auto-scroll on manual click
    }
  };

  const scrollRe = (direction) => {
    if (scrollRefRe.current) {
      const amount = 300; // pixels to scroll per click
      scrollRefRe.current.scrollBy({
        left: direction === "left" ? -amount : amount,
        behavior: "smooth",
      });
      setIsAutoScrolling(false); // pause auto-scroll on manual click
    }
  };

  const scrollPopular = (direction) => {
    if (scrollRefPopular.current) {
      const amount = 300; // pixels to scroll per click
      scrollRefPopular.current.scrollBy({
        left: direction === "left" ? -amount : amount,
        behavior: "smooth",
      });
      setIsAutoScrolling(false); // pause auto-scroll on manual click
    }
  };
  const scrollSearch = (direction) => {
    if (scrollRefSearch.current) {
      const amount = 300; // pixels to scroll per click
      scrollRefSearch.current.scrollBy({
        left: direction === "left" ? -amount : amount,
        behavior: "smooth",
      });
      setIsAutoScrolling(false); // pause auto-scroll on manual click
    }
  };

  useEffect(() => {
    loadMenuCategory();
    loadMenu();
    loadMenupoplaure();
    loadProfileDetails();
    getImages();
  }, [selectedStore]);

  const loadProfileDetails = async () => {
    try {
      let res = await simpleGetCallWithErrorResponse(ApiConfig.GET_PROFILE);
      // console.log("resgetppp",res)
      if (res?.json.success) {
        // localStorage.setItem('selected_location', JSON.stringify(res?.json))
        setselected_location(res?.json);
      }
      return true;
    } catch (e) {
      return false;
      // console.log("abcdefg",e)
    }
  };

  const loadMenuCategory = async () => {
    try {
      setIsLoad(true); // 🔥 show skeleton before API

      let res = await simpleGetCallWithErrorResponse(
        `${ApiConfig?.GET_MENU_CATEGORY}?restaurant_id=${selectedStore}`
      );

      if (res?.json.success) {
        setMenuCategoryList(res?.json.data || []);
        setIsLoad(false); // 🔥 data loaded → show cards
      } else {
        setMenuCategoryList([]);
        // setIsLoad(true);
        setIsLoad(false); // 🔥 data loaded → show cards
      }
    } catch (error) {
      setMenuCategoryList([]);
      // setIsLoad(true); // stop skeleton even on error
    }
  };

    const getImages = async () => {
    try {
      let res = await PostCallWithErrorResponse(`${ApiConfig?.GET_IMAGES}`);
      if (res?.json?.success) {
     
          setDefaultImgs({
            item_image: res?.json?.data?.item_image,
            category_image: res?.json?.data?.category_image,
          })
      localStorage.setItem('defaultImgs', JSON.stringify(res.json.data) || "hi");
      }
    } catch (error) {
      // dispatch(setCountCart({ cartCount: 0 }));
    }
  };

  const loadMenu = async () => {
    try {
      setIsLoad(true); // 🔥 show skeleton before API
    
      let res = await simpleGetCallWithErrorResponse(
        `${ApiConfig?.GET_MENU}?restaurant_id=${selectedStore}&page_limit=25&type=Recommended${extraParam}`
      );

      if (res?.json.success) {
        // console.log("resmenu=>>====================", JSON.stringify(res));
        setMenuList(res?.json.data);
        setIsLoad(false); // 🔥 data loaded → show cards
      } else {
        setMenuList([]);
      }
    } catch (error) {
      // alert(error?.message);
      // AlertDialogDanger(error?.message);
    }
  };

  const loadMenupoplaure = async () => {
    try {
      setIsLoad(true); // 🔥 show skeleton before API

    
      let res = await simpleGetCallWithErrorResponse(
        `${ApiConfig?.GET_MENU}?restaurant_id=${selectedStore}&page_limit=25&type=Popular${extraParam}`
      );

      if (res?.json.success) {
        // console.log("resmenu=>>====================", JSON.stringify(res));
        setMenuPopularList(res?.json.data);
        setIsLoad(false); // 🔥 data loaded → show cards
      } else {
        setMenuPopularList([]);
      }
    } catch (error) {
      setMenuPopularList([])
      // alert(error?.message);
      // AlertDialogDanger(error?.message);
    }
  };

  /* ----------------- FILTERED LISTS ----------------- */

  const filteredCategories = MenuCategoryList?.filter((item) =>
    item?.category_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredMenuList = menuList?.filter((item) =>
    item?.item_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredPopularList = menuPopularList?.filter((item) =>
    item?.item_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getTimeAndDistanceData = async (start, end) => {
    try {
      const result = await timeAndDistance(start, end);

      if (result && result.duration) {
        setDeliveryDistance(result.distanceInKm);
      }
    } catch (error) {
      console.error("Error calculating time and distance:", error);
    }
  };

  const [restaurantStatus, setRestaurantStatus] = useState(false);

  const getRestaurant = useCallback(
    async (id) => {
      try {
        const res = await simpleGetCallWithErrorResponse(
          `${ApiConfig.GET_RESTAURANT}/${id}`
        );

        if (res?.json.success) {
          // ✅ Update local states
          localStorage.setItem(
            "selected_restaurant_details",
            JSON.stringify(res.json.data)
          );

          setRestaurantDetails(res.json.data);
          setRestaurantStatus(res.json.data.store_status !== "0");

          // ✅ Calculate time and distance
          const start = `${res.json.data.restaurant_longitude},${res.json.data.restaurant_latitude}`;
          const end = `${selected_location?.user_longitude},${selected_location?.user_latitude}`;
          // const end = `${"76.948242"},${"8.885072"}`;

          if (getTimeAndDistanceData) {
            getTimeAndDistanceData(start, end);
          }
        }
      } catch (error) {
        console.error("Error fetching restaurant:", error);
      }
    },
    [selected_location, getTimeAndDistanceData]
  );

  // Automatically fetch when selectedStore changes
  useEffect(() => {
    if (selectedStore) {
      getRestaurant(selectedStore);
      getRestaurantSetting();
      handleUpdateDefault();
    }
  }, [selectedStore]);

  const getRestaurantSetting = useCallback(
    async (id) => {
      try {
        const res = await simpleGetCallWithErrorResponse(
          `${ApiConfig.RESTAURANT_DISPATCH_SETTINGS}`
        );

        if (res?.json.success) {
          setRestaurantDispatchSettings(res?.json.data);
          setRestaurantConfig(res?.json.data);
          localStorage.setItem(
            "restaurantGeofenceRadiusKm",
            JSON.stringify(res?.json.data?.delivery_range_km)
          );
           localStorage.setItem(
            "restaurant_config",
            JSON.stringify(res?.json.data)
          );
          setRestaurantGeofenceRadiusKm(res?.json.data?.delivery_range_km ?? 6);
        }
      } catch (error) {
        console.error("Error fetching restaurant:", error);
      }
    },
    [selectedStore, selected_location, getTimeAndDistanceData]
  );

  const handleUpdateDefault = async () => {
    try {
      const requestBody = {
        user_id: loginData.id,
        restaurant_id: selectedStore,
      };

      const res = await PatchMultipartWithAuthCallWithErrorResponse(
        ApiConfig.PATCH_RESTAURANT_SELECT,
        JSON.stringify(requestBody)
      );

      if (res?.success) {
        // notifySuccess(res.json?.message)
      } else {
        // AlertDialogDanger(res?.message);
        //  notifyError(res.json?.message)
      }
    } catch (e) {
      console.error(e);
    } finally {
      // setIsUpdating(false);
    }
  };

  useEffect(() => {
    const loadfetchDropdownList = async () => {
      console.log("call my api");
      try {
        let res = await simpleGetCallWithErrorResponseWife(
          // `${ApiConfig.BASE_URL}/api/v1/shops/storeDropDown/`
          `${ApiConfig.GET_RESTAURANT_LIST}`
        );

        console.log("API Response:", res);


        if (res?.json.success && Array.isArray(res?.json.data)) {
          const hasValidLocation =
            selected_location?.user_latitude &&
            selected_location?.user_longitude;
          let resultList = [];

          if (hasValidLocation || true) {
            await Promise.all(
              res.json.data.map(async (item) => {
                const start = `${item.restaurant_longitude},${item.restaurant_latitude}`;
                const end = `${selected_location.user_longitude},${selected_location.user_latitude}`; 
                    //  localStorage.setItem("store_Location", JSON.stringify(res.json.data));

                try {
                  const result = await timeAndDistance(start, end);
                  console.log("result---", result, start, end);

                  if (result && result.distanceInKm != null) {
                    item.Distance = result;
                    resultList.push(item);
                  }
                } catch (error) {
                  console.error("Error fetching time and distance:", error);
                }
              })
            );

            // Sort by distanceInKm
            resultList.sort((a, b) => {
              if (b?.store_status != a?.store_status) {
                return b?.store_status - a?.store_status;
              }
              const distanceA = a.Distance?.distanceInKm ?? Infinity;
              const distanceB = b.Distance?.distanceInKm ?? Infinity;
              return distanceA - distanceB;
            });

            console.log("Sorted list based on distance:", resultList);
          } else {
            // No location: use unsorted list
            console.warn(
              "selected_location is missing, showing unsorted list."
            );
            resultList = res.json.data;
          }

        }

        //    const storeList = res.json?.stores?.map((store) => ({
        //   value: store.id,
        //   label: store.restaurant_name,
        //   id: store.restID,
        // }));
        const storeList = res?.json.data?.map((store) => ({
          value: store.id,
          label: store.restaurant_name,
          id: store.id,
          store_status: store.store_status,
          Distance: store.Distance,
        }));

            localStorage.setItem("store_list", JSON.stringify(storeList));

const selectedStoreWeb = res?.json?.data?.filter(
  (store) => Number(store.restaurant_id) === Number(selectedStore)
);

     

          console.log("resultList=====>--", selectedStoreWeb);
localStorage.setItem("store_Location", JSON.stringify(selectedStoreWeb));
    
     
        setSelectedStoreObject(storeList?.[0] || null);
        if (!selectedStore) {
          localStorage.setItem(
            "selectedStore",
            JSON.stringify(storeList?.[0]?.value || null)
          );
          setSelectedStore(storeList?.[0]?.value || null);
        }
        setStoresList(storeList || []);
      } catch (error) {
        console.error("API call error:", error);
      }
    };
    loadfetchDropdownList();
  }, [selectedStore, selected_location]);

  const profileData = JSON.parse(localStorage.getItem("LOGIN_DATA"));

  const addToCart = async (item, variationId = null) => {
    
    try {
      // find selected variation if available
      // const item_variation_id = item?.variations?.find((v) => v?.selected)?.item_variation_id;
      const item_variation_id =
        item?.item_allow_variation == 1
          ? variationId
          : null;

      const requestBody = {
        item_id: item?.item_id,
        variation_id: item_variation_id ?? null,
        user_id: profileData.id,
        order_quantity: 1,
        addons: getAddonDataArr(item),
      };

      const res = await PostCallWithErrorResponse(
        `${ApiConfig?.Add_TO_CART}`,
        JSON.stringify(requestBody)
      );
      console.log("Add to cart response:", res);

      if (res.json?.success) {
        loadMenu();
        loadMenupoplaure();
        notifySuccess(res.json?.message);
        // add item id to added list
        // setItemAddedList((prev) => [...prev, item.item_id]);
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  };

  const categoryItem = (cat_id) => {
    let item = {};
    item = MenuCategoryList?.filter((item = item.category_id === cat_id));
    return item;
  };

  const loadCart = async () => {
    try {
      let res = await GetWithAuth(ApiConfig.CART_LIST);
      if (res?.json.success) {
        let val = res.json.data.reduce((acc, i) => acc + i.order_quantity, 0);
        setCountCart(val);
      }
    } catch (error) {
      setCountCart(0);
    }
  };

  const loadInitialData = useCallback(
    async (id) => {
      if (!id) return;
      // setIsPageLoading(true);
      try {
        await Promise.all([
          getRestaurant(id),
          loadCart(),
          //   postWithAuthCallWithErrorResponse(ApiConfig.GET_IMAGES).then(res => res?.success && dispatch(setImages({
          //   item_image: res?.data?.item_image,
          //   category_image: res?.data?.category_image,
          // }))),
          
          GetWithAuth(
            `${ApiConfig.GET_MENU_CATEGORY}?restaurant_id=${id}`
          ).then(
            (res) => res?.json.success && setMenuCategoryList(res.json.data)
          ),
          // GetWithAuth(`${ApiConfig.GET_MENU}?restaurant_id=${id}&page_limit=5&type=Recommended`).then(res => res?.json.success && setItemListData( res.json.data )),
          GetWithAuth(
            `${ApiConfig.GET_MENU}?restaurant_id=${id}&page_limit=5&type=Popular${extraParam}`
          ).then(
            (res) => res?.json.success && setMenuPopularList(res.json.data)
          ),
          getRestaurantSetting().catch((err) => {
            console.error("getRestaurantDispatchSetting failed:", err);
          }),
          // --- END ADD ---
        ]);
        // await loadMenuBottom(1);
      } catch (error) {
        console.error("Failed to load initial data:", error);
      } finally {
        // setIsPageLoading(false);
      }
    },
    [/* dispatch, */ getRestaurant, selectedStore]
  );

  function isObjectEmpty(obj) {
    // Check if the input is actually an object and not null
    if (typeof obj !== "object" || obj === null) {
      return false; // Or throw an error, depending on desired behavior
    }
    return Object.keys(obj).length === 0;
  }

  const loadAddressList = async () => {
    const res = await simpleGetCallWithErrorResponse(
      ApiConfig.CREATE_OR_GET_UPDATE_ADDRESS
    );
    if (res?.json.success) {
      // setAddressList(res.json?.data);
      let filter = res?.json.data?.filter(
        (i) => i?.user_address_is_default == 1
      );
      if (filter?.length > 0) {
        // dispatch(setLocation({ selected_location: filter?.[0] }));
        localStorage.setItem(
          "user_selected_location",
          JSON.stringify(filter?.[0])
        );
        if (isObjectEmpty(selected_location)) {
          set_selected_location(filter?.[0]);
        }

        // navigation.navigate("DrawerScreen");
      }
    }
  };

  useEffect(() => {
    loadAddressList();
  }, []);

  const [menuListFilter, setMenuListFilter] = useState([]);

  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [hasMoreSearchResults, setHasMoreSearchResults] = useState(false);
  console.log("hasMoreSearchResults", hasMoreSearchResults);

 const loadMenuSearch = useCallback(
  async (isPaginating = false) => {
    if (!selectedStore) return;

    if (!searchTerm || searchTerm.trim() === "") {
      setMenuListFilter([]);
      setHasMoreSearchResults(false);
      setIsSearchLoading(false);
      return;
    }

    setIsSearchLoading(true);

    try {
      const queryParams = [
        `search=${encodeURIComponent(searchTerm)}`,
        `restaurant_id=${selectedStore}`,
      ];
      const url = `${ApiConfig.GET_MENU}?${queryParams.join("&")}${extraParam}`;

      const res = await GetWithAuth(url);

      if (res?.success) {
        setHasMoreSearchResults(true);
        setMenuListFilter(res.data);
      } else {
        setMenuListFilter([]);
        setHasMoreSearchResults(false);
      }
    } catch (error) {
      console.log("Search error:", error);
      setHasMoreSearchResults(false);
    } finally {
      setIsSearchLoading(false);
    }
  },
  [searchTerm, selectedStore]
);

useEffect(() => {
  const delay = setTimeout(() => {
    loadMenuSearch(false);
  }, 400); // 400ms delay

  return () => clearTimeout(delay);
}, [searchTerm, selectedStore]);



const delay = 1500 + Math.random() * 1000; // 1.5s–2.5s

 useEffect(() => {
    if (!selectedStore) return;
  let timeoutId;
    const eventName = `${selectedStore}/updated-menu`;

    const unsubscribe = subscribeToEvent(eventName, (data) => {
      console.log("Menu updated:", data);

      // 🔥 Call your APIs
    timeoutId = setTimeout(() => {
    loadMenupoplaure();
    loadMenu();
}, delay);
    });

    return () => {
      if (timeoutId) {
      clearTimeout(timeoutId);
    }
      unsubscribe();
    };
  }, [subscribeToEvent, selectedStore]);


  return (
    <>
      <div className="main-home-wrapper" id="cx-main">
        <div className="Carousel-wrapper">
          <Carousel>
            <Carousel.Item>
              <div className="caro-slide-wrapper">
                <Link to="#">
                  <img src={bg_slide_green1} alt="" />
                </Link>
              </div>
            </Carousel.Item>
            <Carousel.Item>
              <div className="caro-slide-wrapper">
                <Link to="#">
                  <img src={bg_slide_green2} alt="" />
                </Link>
              </div>
            </Carousel.Item>
            <Carousel.Item>
              <div className="caro-slide-wrapper">
                <Link to="#">
                  <img src={bg_slide_green3} alt="" />
                </Link>
              </div>
            </Carousel.Item>
            <Carousel.Item>
              <div className="caro-slide-wrapper">
                <Link to="#">
                  <img src={bg_slide_green4} alt="" />
                </Link>
              </div>
            </Carousel.Item>
            <Carousel.Item>
              <div className="caro-slide-wrapper">
                <Link to="#">
                  <img src={bg_slide_green5} alt="" />
                </Link>
              </div>
            </Carousel.Item>
            <Carousel.Item>
              <div className="caro-slide-wrapper">
                <Link to="#">
                  <img src={bg_slide_green6} alt="" />
                </Link>
              </div>
            </Carousel.Item>
            <Carousel.Item>
              <div className="caro-slide-wrapper">
                <Link to="#">
                  <img src={bg_slide_green7} alt="" />
                </Link>
              </div>
            </Carousel.Item>
          </Carousel>
        </div>
        {console.log("selectedStroeObject--", selectedStroeObject)}
        {/* {(selectedStroeObject?.store_status == 0 || parseFloat(selectedStroeObject?.Distance?.distanceInKm)?.toFixed(2)>restaurantGeofenceRadiusKm) ? (
        <div className="mt-2">
        <ServiceTicker message= {selectedStroeObject?.store_status == 0 ? 'Restaurant is closed.' : 'Service not available at your current location.' }  />
        </div>
        ) : null} */}
        <div className="">
          <div className="main-cards-wrapper">
            <section className="top-doctors-wrapper">
          
              <div
                className="heading-view-all mt-19"
                style={{ marginTrim: "20px" }}
              >
                {hasMoreSearchResults == true ? <>
                <h5>Search Results</h5> 
                </>:<>
                   <h5>Category</h5>
                </>}
                
             
              </div>
      
      {searchTerm && ( 
                  <div className="doctors-card-wrapper d-flex flex-row flex-nowrap overflow-hidden">
                     <div className="menu-scroll-container position-relative">
                 
                  {/* Left Arrow */}
                {hasMoreSearchResults == true && (
                  <button
                    className="scroll-arrow left"
                    onClick={() => scrollSearch("left")}
                  >
                    <ChevronLeft size={28} />
                  </button>
                  )}

                  {/* Scrollable Cards */}
                  <div
                    ref={scrollRefSearch}
                    className="doctors-card-wrapper d-flex flex-row flex-nowrap overflow-hidden"
                  >

                    
                            {isApiLoad ? (
                <SkeletonLoader />
              ) : searchTerm && menuListFilter.length > 0 ? (
                menuListFilter.map((item, index) => (



                    <div 
                    
                     key={index}
                        className={`position-relative ${
                          item?.item_active == 0 ||
                          item?.in_stock == 0 ||
                          (item?.in_stock == 1 && item?.quantity == 0) ||
                          (item?.item_allow_variation === 1 &&
                            item?.in_stock == 1 &&
                            item?.variations?.length == 0)
                            ? "greyscale"
                            : ""
                        }`}
                    >

                      <div className="doctors-card">
                        {item.is_ready_to_use && (
                          <div className="ready-to-use-badge">
                            <span className="badge-icon">✦</span> Ready to Eat
                          </div>
                        )}
                        <div className="img-section">
                          <img
                            src={
                              item.item_image_url == null
                                ? ( defaultImgs?.item_image || dr_2)
                                : item.item_image_url
                            }
                            alt={item.item_name}
                            className="img-dr"
                            onError={(e) => (e.target.src = ( defaultImgs?.item_image || dr_2))}
                          />

                         
                           
                        
                        </div>
  <div className="wrapper d-flex justify-content-between align-items-center" style={{   marginTop: "15px",}}>
                        <div
                          className="name-rating"
                          style={{
                            color: "#1b5354",
                            fontWeight: "600",
                         
                          }}
                        >
                          <label className="name" >{item.item_name}</label>
                        </div>
                        

                        {hasMoreSearchResults == true  && (
                        
                             <div className="left ">
                                <label
                                  className="name"
                                  style={{
                                    color: "#1b5354",
                                    fontWeight: "600",
                                  }}
                                >
                                  ₹
                                  {item?.item_allow_variation == 1
                                    ? Number(
                                        item?.variations?.[0]
                                          ?.variation_price ?? 0
                                      ) + Number(item.item_price)
                                    : item.item_price}
                                </label>
                              </div>
                           
                        )}
                        
                      </div>
                      <div className="home-menu-section">
                        { (item?.item_allow_variation == 1 || item. item_allow_addon) ? (
                             <div className="text-center">
                                <p style={{margin: "0", fontSize:'14px' , color:'#006600' , fontStyle:'italic'}}>Customization available</p>
                                 </div>
                                 ) : null}
                                   {itemsAdded[item.item_id] ? (
                              <button
                                className="button-main button-color-white bg-secondary "
                                id="btn-added2---"
                                disabled
                                onClick={() => addToCart(item)}
                              >
                             {/*    <img src={ic_added_item} alt="" />  */}Item Added
                              </button>
                            ) : (
                              <button
                                className="button-main"
                                onClick={() => handleAddToCart(item)}
                              >
                                {/* <img src={ic_bag_light} alt="" /> */} Add to Cart
                              </button>
                            )}
                         </div>
                         </div>
        {item?.item_active == 0 ||
                          item?.in_stock == 0 ||
                          (item?.in_stock == 1 && item?.quantity == 0) ||
                          (item?.item_allow_variation === 1 &&
                            item?.in_stock == 1 &&
                            item?.variations?.length == 0) ? (
                            <div className="out-of-stock-overlay">
                              <span className="out-of-stock-text">
                                Out of Stock
                              </span>
                            </div>
                          ) : null}

                          
                    </div>
                      ))
              ) : searchTerm ? (
                <p>No results found for "{searchTerm}"</p>
              ) : (
                // <p>No Recommended Items</p>
                <></>
              )}
              
                  </div>

                      {/* Right Arrow */}
                         {hasMoreSearchResults == true && (
                  <button
                    className="scroll-arrow right"
                    onClick={() => scrollSearch("right")}
                  >
                    <ChevronRight size={28} />
                  </button>
                         )}
                  </div>
                  </div>
                  )}
                 
           
{hasMoreSearchResults == true ? <>
<VariationModal
  showModal={showVariationModal}
  item={variationData}   // ⬅ full item: variations + addons
  onClose={handleCloseVariationModal}
  onAdd={(customizedItem, variationId) => {
    handleAddToCartVariation(customizedItem , variationId);
  }}
/>
</>:<>

 <div className="doctors-card-wrapper row">
                <div className="menu-scroll-container position-relative">
                  {/* Left Arrow */}
                  <button
                    className="scroll-arrow left"
                    onClick={() => scroll("left")}
                  >
                    <ChevronLeft size={28} />
                  </button>

                  {/* Scrollable Cards */}
                  <div
                    ref={scrollRef}
                    className="doctors-card-wrapper d-flex flex-row flex-nowrap overflow-hidden"
                  >
                    {isApiLoad ? (
                      <SkeletonLoader />
                    ) : filteredCategories && filteredCategories.length > 0 ? (
                      filteredCategories.map((item, index) => (
                        <div key={index}>
                          <div className="doctors-card">
                            {item.is_ready_to_use && (
                              <div className="ready-to-use-badge">
                                <span className="badge-icon">✦</span> Ready to Eat
                              </div>
                            )}
                            <div className="img-section">
                              <img
                                src={
                                  item.category_image_url == null
                                    ? ( defaultImgs?.category_image || dr_2)
                                    : item.category_image_url
                                }
                                alt={item.category_name}
                                className="img-dr"
                                onError={(e) => (e.target.src = ( defaultImgs?.category_image || dr_2))}
                              />

                           
                            </div>

                            <div
                              className="name-rating"
                              style={{
                                color: "#1b5354",
                                fontWeight: "600",
                                marginTop: "15px",
                              }}
                            >
                              <label className="name"   style={{
                            color: "#1b5354",
                            fontWeight: "600",
                            fontSize:'15px'
                         
                          }}>
                                {item.category_name}
                              </label>
                            </div>
                            <div className="home-menu-section">
                               <Link
                                to={`/category-list`}
                                state={{
                                  category_item: item,
                                  MenuCategoryList,
                                }}
                              >
                                <button
                                  className="button-main"
                                  onClick={() => {
                                    localStorage.setItem(
                                      "category_id",
                                      JSON.stringify(item.category_id)
                                    );
                                    localStorage.setItem(
                                      "category_name",
                                      JSON.stringify(item.category_name)
                                    );
                                  }}
                                >
                                  Add Now{" "}
                                  <img src={ic_right_arrow_circle} alt="" />
                                </button>
                              </Link>
                          </div>
                          </div>
                          
                        </div>
                      ))
                    ) : (
                      // <p>No Categories Found</p>
                      <></>
                    )}
                  </div>

                  {/* Right Arrow */}
                  <button
                    className="scroll-arrow right"
                    onClick={() => scroll("right")}
                  >
                    <ChevronRight size={28} />
                  </button>
                </div>
              </div>
</>}
             
            </section>
          </div>
        </div>
{hasMoreSearchResults == true ? <></>:<> 
  <div className="top-doctors-wrapper">
          <div className="main-cards-wrapper">
            <div className="artical-main-wrapper">
              <div className="heading-view-all">
                <h5>Recommended</h5>
                {/* <Link to="#" className="view-all">
                  View All <img src={ic_arrow_right_white} alt="" />
                </Link> */}
              </div>
            </div>
            <div className="artical-card-wrapper row">
              <div className="menu-scroll-container position-relative">
                {/* Left Arrow */}
                <button
                  className="scroll-arrow left"
                  onClick={() => scrollRe("left")}
                >
                  <ChevronLeft size={28} />
                </button>

                {/* Scrollable Cards */}
                <div
                  ref={scrollRefRe}
                  className="doctors-card-wrapper d-flex flex-row flex-nowrap overflow-hidden"
                >
             
                 
                  {isApiLoad ? (
                    <SkeletonLoader />
                  ) : menuList && menuList.length > 0 ? (
                    menuList.map((item, index) => (
                      <div
                        key={index}
                        className={`position-relative ${
                          item?.item_active == 0 ||
                          item?.in_stock == 0 ||
                          (item?.in_stock == 1 && item?.quantity == 0) ||
                          (item?.item_allow_variation === 1 &&
                            item?.in_stock == 1 &&
                            item?.variations?.length == 0)
                            ? "greyscale"
                            : ""
                        }`}
                      >
                        <div className="doctors-card">
                          {item.is_ready_to_use && (
                            <div className="ready-to-use-badge">
                              <span className="badge-icon">✦</span> Ready to Eat
                            </div>
                          )}
                          <div className="img-section">
                            <img
                              src={
                                item.item_image_url == null
                                  ? ( defaultImgs?.item_image || dr_2)
                                  : item.item_image_url
                              }
                              alt={item.item_name}
                              className="img-dr"
                              height="240px"
                              width="60px"
                              onError={(e) => (e.target.src =  ( defaultImgs?.item_image || dr_2) )}
                            />

                        
                          </div>
                          <div className="name-rating">
                            <div className="wrapper">
                              <div className="left">
                                <label
                                  className="name"
                                  style={{
                                    color: "#1b5354",
                                    fontWeight: "600",
                                    marginTop: "5px",
                                  }}
                                >
                                  {item.item_name}
                                </label>
                              </div>
                              <div className="left">
                                <label
                                  className="name"
                                  style={{
                                    color: "#1b5354",
                                    fontWeight: "600",
                                  }}
                                >
                                  ₹
                                  {item?.item_allow_variation == 1
                                    ? Number(
                                        item?.variations?.[0]
                                          ?.variation_price ?? 0
                                      ) + Number(item.item_price)
                                    : item.item_price}
                                </label>
                              </div>
                             
                            </div>

                             {(item?.item_allow_variation == 1 || item.item_allow_addon) ? (
                             <div className="text-center">
                                <p style={{ margin: "0",fontSize:'14px' , color:'#006600' , fontStyle:'italic'}}>Customization available</p>
                                 </div>
                                 ) : null}

                                 <div className="home-menu-section">
                                     {itemsAdded[item.item_id] ? (
                              <button
                                className="button-main button-color-white bg-secondary "
                                id="btn-added2--"
                                disabled
                                onClick={() => addToCart(item)}
                              >
                                {/* <img src={ic_added_item} alt="" />  */}Item Added
                              </button>
                            ) : (
                              <button
                                className="button-main "
                                onClick={() => handleAddToCart(item)}
                              >
                              {/*   <img src={ic_bag_light} alt="" /> */} Add to Cart
                              </button>
                            )}
                          </div>
                          </div>

                          {item?.item_active == 0 ||
                          item?.in_stock == 0 ||
                          (item?.in_stock == 1 && item?.quantity == 0) ||
                          (item?.item_allow_variation === 1 &&
                            item?.in_stock == 1 &&
                            item?.variations?.length == 0) ? (
                            <div className="out-of-stock-overlay">
                              <span className="out-of-stock-text">
                                Out of Stock
                              </span>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>Loading...</p>
                  )}
                </div>

                {/* Right Arrow */}
                <button
                  className="scroll-arrow right"
                  onClick={() => scrollRe("right")}
                >
                  <ChevronRight size={28} />
                </button>
              </div>
            </div>
          </div>
        </div>
</>}
      
{hasMoreSearchResults == true ? <></>:<> 
    <div className="main-cards-wrapper" id="top-selling-wrapper">
          <section className="top-doctors-wrapper">
            <div className="heading-view-all">
              <h5>Popular Items</h5>
              {/* <Link to="/Medicines" className="view-all">
                View All <img src={ic_arrow_right_green} alt="" />
              </Link> */}
            </div>

            <div className="doctors-card-wrapper row">
              <div className="menu-scroll-container position-relative">
                {/* Left Arrow */}
                <button
                  className="scroll-arrow left"
                  onClick={() => scrollPopular("left")}
                >
                  <ChevronLeft size={28} />
                </button>

                {/* Scrollable Cards */}
                <div
                  ref={scrollRefPopular}
                  className="doctors-card-wrapper d-flex flex-row flex-nowrap overflow-hidden"
                >
              

                  {isApiLoad ? (
                    <SkeletonLoader />
                  ) : menuPopularList && menuPopularList.length > 0 ? (
                    menuPopularList.map((item, index) => (
                      <div
                        key={index}
                        className={`position-relative ${
                          item?.item_active == 0 ||
                          item?.in_stock == 0 ||
                          (item?.in_stock == 1 && item?.quantity == 0) ||
                          (item?.item_allow_variation === 1 &&
                            item?.in_stock == 1 &&
                            item?.variations?.length == 0)
                            ? "greyscale"
                            : ""
                        }`}
                      >
                        <div className="doctors-card">
                          {item.is_ready_to_use  && (
                            <div className="ready-to-use-badge">
                              <span className="badge-icon">✦</span> Ready to Eat
                            </div>
                          )}
                          <div className="img-section">
                            <img
                              src={
                                item.item_image_url == null
                                  ? ( defaultImgs?.item_image || dr_2)
                                  : item.item_image_url
                              }
                              alt={item.item_name}
                              className="img-dr"
                              height="240px"
                              width="60px"
                              onError={(e) => (e.target.src = ( defaultImgs?.item_image || dr_2))}
                            />

                            {/* ✅ Check if item.cart is null */}
                           
                          </div>

                          <div className="name-rating">
                            <div className="wrapper">
                              <div className="left">
                                <label className="name">{item.item_name}</label>
                              </div>
                              <div className="left">
                                <label className="name">
                                  ₹
                                  {item?.item_allow_variation == 1
                                    ? Number(
                                        item?.variations?.[0]
                                          ?.variation_price ?? 0
                                      ) + Number(item.item_price)
                                    : item.item_price}
                                </label>
                              </div>
                            </div>
                              {(item?.item_allow_variation == 1 || item.item_allow_addon) ? (
                             <div className="text-center">
                                <p style={{margin: "0", fontSize:'14px' , color:'#006600' , fontStyle:'italic'}}>Customization available</p>
                                 </div>
                                 ): null}
                          </div>
                           <div className="home-menu-section">
                           {item.cart == null ? (
                           
                              <button
                                className="button-main"
                                // onClick={() => addToCart(item)}
                                style={{position:'static'}}
                                onClick={() => handleAddToCart(item)}
                              >
                            {/*     <img src={ic_bag_light} alt="" /> */} Add to Cart
                              </button>
                            ) : (
                              <button
                                className="button-main button-color-white bg-secondary"
                                id="btn-added---"
                                disabled
                              >
                                {/* <img src={ic_added_item} alt="" /> */} Item Added
                              </button>
                            )}
                        </div>
                        </div>

                        {item?.item_active == 0 ||
                        item?.in_stock == 0 ||
                        (item?.in_stock == 1 && item?.quantity == 0) ||
                        (item?.item_allow_variation === 1 &&
                          item?.in_stock == 1 &&
                          item?.variations?.length == 0) ? (
                          <div className="out-of-stock-overlay">
                            <span className="out-of-stock-text">
                              Out of Stock
                            </span>
                          </div>
                        ) : null}
                      </div>
                    ))
                  ) : (
                    <p>Loading...</p>
                  )}
                </div>
                {/* <AppDownloadPromptWrapper showPrompt={showPrompt}
              setShowPrompt={setShowPrompt}
              proceedToCheckoutButtonFunction={()=> setShowPrompt(false)}
              /> */}
                {/* Right Arrow */}
                <button
                  className="scroll-arrow right"
                  onClick={() => scrollPopular("right")}
                >
                  <ChevronRight size={28} />
                </button>
              </div>
            </div>
          </section>
        </div>

  {/* ── Our Menu preview section (below Popular Items) ── */}
  <div className="main-cards-wrapper" id="menu-section-wrapper">
    <section className="top-doctors-wrapper">
      <div className="heading-view-all">
        <h5>Menu</h5>
        
      </div>
      <div className="text-end mt-0 mb-2">
      <Link to="/menu" className="mc-view-all">
          View All <img src={ic_arrow_right_green} alt="" />
        </Link>
        </div>
      <HomeMenuSection />
    </section>
  </div>

<VariationModal
  showModal={showVariationModal}
  item={variationData}   // ⬅ full item: variations + addons
  onClose={handleCloseVariationModal}
   onAdd={(customizedItem, variationId) => {
    handleAddToCartVariation(customizedItem , variationId);
  }}
/>
</>}

    

        <div className="top-scroll-btn-main">
          <button onClick={topScroll} className="top-scroll-btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="46"
              height="47"
              viewBox="0 0 46 47"
              fill="none"
            >
              <path
                d="M23.0007 4.25732C12.4207 4.25732 3.83398 12.844 3.83398 23.424C3.83398 34.004 12.4207 42.5907 23.0007 42.5907C33.5807 42.5907 42.1673 34.004 42.1673 23.424C42.1673 12.844 33.5807 4.25732 23.0007 4.25732ZM29.7665 23.4815C29.479 23.769 29.1148 23.9032 28.7507 23.9032C28.3865 23.9032 28.0223 23.769 27.7348 23.4815L24.4382 20.1848V30.1323C24.4382 30.9182 23.7865 31.5698 23.0007 31.5698C22.2148 31.5698 21.5632 30.9182 21.5632 30.1323V20.1848L18.2665 23.4815C17.7107 24.0373 16.7907 24.0373 16.2348 23.4815C15.9675 23.211 15.8176 22.846 15.8176 22.4657C15.8176 22.0853 15.9675 21.7203 16.2348 21.4498L21.9848 15.6998C22.5407 15.144 23.4606 15.144 24.0165 15.6998L29.7665 21.4498C30.3223 22.0057 30.3223 22.9257 29.7665 23.4815Z"
                fill="#000000ff"
              />
            </svg>
          </button>
        </div>

        <footer>
          <div className="footer-wrapper row">
            <div className="col-md-3">
              {/* <div className="menu-section">
                <h6>About</h6>
                <ul>
                  <li>
                    <Link to="#">Company</Link>
                  </li>
                  <li>
                    <Link to="#">Terms & Conditions</Link>
                  </li>
                  <li>
                    <Link to="#">Contact Us</Link>
                  </li>
                </ul>
              </div> */}
            </div>
          </div>
          <div className="social-media-wrapper">
            <div className="right">
              <label htmlFor="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                >
                  <path
                    d="M10.08 11.0944C10.13 10.7644 10.24 10.4744 10.38 10.2244C10.52 9.97437 10.72 9.76437 10.97 9.60437C11.21 9.45437 11.51 9.38438 11.88 9.37438C12.11 9.38438 12.32 9.42438 12.51 9.50438C12.71 9.59438 12.89 9.71438 13.03 9.86438C13.17 10.0144 13.28 10.1944 13.37 10.3944C13.46 10.5944 13.5 10.8144 13.51 11.0344H15.3C15.28 10.5644 15.19 10.1344 15.02 9.74438C14.85 9.35438 14.62 9.01438 14.32 8.73438C14.02 8.45437 13.66 8.23438 13.24 8.07438C12.82 7.91438 12.36 7.84438 11.85 7.84438C11.2 7.84438 10.63 7.95437 10.15 8.18437C9.67 8.41437 9.27 8.71438 8.95 9.10437C8.63 9.49437 8.39 9.94437 8.24 10.4644C8.09 10.9844 8 11.5244 8 12.1044V12.3744C8 12.9544 8.08 13.4944 8.23 14.0144C8.38 14.5344 8.62 14.9844 8.94 15.3644C9.26 15.7444 9.66 16.0544 10.14 16.2744C10.62 16.4944 11.19 16.6144 11.84 16.6144C12.31 16.6144 12.75 16.5344 13.16 16.3844C13.57 16.2344 13.93 16.0244 14.24 15.7544C14.55 15.4844 14.8 15.1744 14.98 14.8144C15.16 14.4544 15.27 14.0744 15.28 13.6644H13.49C13.48 13.8744 13.43 14.0644 13.34 14.2444C13.25 14.4244 13.13 14.5744 12.98 14.7044C12.83 14.8344 12.66 14.9344 12.46 15.0044C12.27 15.0744 12.07 15.0944 11.86 15.1044C11.5 15.0944 11.2 15.0244 10.97 14.8744C10.72 14.7144 10.52 14.5044 10.38 14.2544C10.24 14.0044 10.13 13.7044 10.08 13.3744C10.03 13.0444 10 12.7044 10 12.3744V12.1044C10 11.7544 10.03 11.4244 10.08 11.0944ZM12 2.23438C6.48 2.23438 2 6.71438 2 12.2344C2 17.7544 6.48 22.2344 12 22.2344C17.52 22.2344 22 17.7544 22 12.2344C22 6.71438 17.52 2.23438 12 2.23438ZM12 20.2344C7.59 20.2344 4 16.6444 4 12.2344C4 7.82438 7.59 4.23438 12 4.23438C16.41 4.23438 20 7.82438 20 12.2344C20 16.6444 16.41 20.2344 12 20.2344Z"
                    fill="#F2FBFA"
                  />
                </svg>
                © 2026 ZAMZAM RESTUARANT
              </label>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Home;
